import React from 'react'

const Footer = () => {
  const currentYear = new Date().getFullYear() // To make the test dynamic
  const copyrightText = `Copyright © ${currentYear} Albin Issac.All Rights reserved.`
  return <div className='bg-cyan-900 text-sm p-4 text-center text-white'>{copyrightText}</div>
}

export default Footer
